<template>
  <div class="fixedRightNav">
    <div class="rightNav">
      <!-- 个人中心-->
      <el-popover placement="left-end" width="230" trigger="hover">
        <div class="user-box">
          <template v-if="isLogin">
          <el-avatar circle class="user-box-avatar" size="large" :src="userInfo.avatar || avatar"></el-avatar>
          <div class="user-box-info">
            <p class="userName">用户：{{ userInfo.userName }}</p>
            <p class="level">等级：{{ userInfo.level || 0 }}</p>
            <div class="user-box-footer">
              <div class="user-box-footer-item userCenter">
                <i class="el-icon-user"></i>
                <router-link tag="span" to="/myInfomation">个人中心</router-link>
              </div>
              <div class="user-box-footer-item orderCenter">
                <i class="el-icon-tickets"></i>
                <router-link tag="span" to="/myOrderRight">订单中心</router-link>
              </div>
            </div>
          </div>
          </template>
          <div class="user-box-info" v-else>
            <p class="userName">你好，请登录</p>
          </div>
        </div>
        <div class="nav-item" slot="reference" @click="navigateTo('/myInfomation')">
          <el-avatar circle size="small" :src="userInfo.avatar || avatar"></el-avatar>
        </div>
      </el-popover>

      <transition name="el-fade-in-linear">
        <el-popover placement="left-end" width="50" trigger="hover">
          <div class="userPartPop"> 购物车 </div>
          <div class="nav-cart" slot="reference" @click="showCart">
            <i class="el-icon-shopping-cart-2"></i>
            <div class="cart-text">购物车</div>
            <el-badge class="cart-num" :value="cartList.length"></el-badge>
          </div>
        </el-popover>
      </transition>
      <!-- 我看过的 -->
      <transition name="el-fade-in-linear">
        <el-popover popper-class="nolikePopBox" placement="left-end" width="50" trigger="hover">
          <div class="userPartPop"> 我看过的 </div>
          <div class="nav-item" slot="reference"  @click="navigateTo('/myFooter')">
            <i class="el-icon-view"></i>
          </div>
        </el-popover>
      </transition>

      <!--我收藏的-->
      <transition name="el-fade-in-linear">
        <el-popover popper-class="nolikePopBox" placement="left-end" width="50" trigger="hover">
          <div class="userPartPop"> 我收藏的 </div>
          <div class="nav-item" slot="reference" @click="navigateTo('/goodsCollection')">
            <i class="el-icon-star-off"></i>
          </div>
        </el-popover>
      </transition>

      <transition name="el-fade-in-linear">
        <el-popover placement="left-end" width="60" trigger="hover">
          <div class="service-box">
<!--            <div class="service-box-item" @click="$tools.contactService">-->
<!--              <i class="icon el-icon-chat-dot-round"></i>-->
<!--              <div class="service-label">在线客服<el-badge :value="msgCount" v-if="!!msgCount"></el-badge></div>-->
<!--            </div>-->
<!--            <el-divider></el-divider>-->
            <div class="service-box-item" @click="copyNumber(informations.consumerHotline)">
              <i class="icon el-icon-phone-outline"></i>
              <div class="service-label">客服电话</div>
              <div class="number">{{informations.consumerHotline}}</div>
            </div>
          </div>
          <div slot="reference" class="nav-item">
            <el-badge class="cart-num" :is-dot="!!msgCount">
              <i class="el-icon-service"></i>
            </el-badge>
          </div>
        </el-popover>
      </transition>
      <!--公告消息-->
      <transition name="el-fade-in-linear">
        <el-popover popper-class="nolikePopBox" placement="left-end" width="50" trigger="hover">
          <div class="userPartPop">
            <span>公告消息</span>
            <el-badge :value="noticeCount" v-if="!!noticeCount"></el-badge>
          </div>
          <div class="nav-item" slot="reference" @click="navigateTo('/noticeList')">
            <el-badge class="cart-num" :is-dot="!!noticeCount">
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>
        </el-popover>
      </transition>

      <transition name="el-fade-in-linear">
        <el-popover popper-class="backTopBox" placement="left-end" width="100" trigger="hover">
          <div class="userPartPop">
            回到顶部
          </div>
          <div slot="reference" class="nav-item">
              <el-backtop :right="0" :bottom="10">
                <i class="el-icon-upload2"></i>
              </el-backtop>
          </div>
        </el-popover>
      </transition>
    </div>

    <!-- 购物车 开始 -->
    <el-drawer class="drawerCart" size="400px" :modal="false" :visible.sync="cartShow">
      <p class="drawerCartTitle" slot="title">
        <i class="icon el-icon-shopping-cart-2"></i>
        <span class="gotoShopText">购物车</span>
      </p>
      <div class="cart-content">
        <template v-if="cartList.length">
          <div class="cartTip">
            <div class="good-box" @click="$tools.showGoodInBlank(item.id)"
                    v-for="item in cartList" :key="item.cartSpecificationDetails.id">
              <el-image class="good-cover" :src="item.photos"></el-image>
              <div class="good-info">
                <div class="good-title">{{ item.name }}</div>
                <div class="good-tags">{{ item.cartSpecificationDetails && item.cartSpecificationDetails.attributeContent }}</div>
                <div class="good-count">
                  <span class="price">{{ item.realprice | decimal }}</span>
                  <span class="count">× {{ item.number }}</span>
                </div>
              </div>
            </div>
            <div class="cart-footer">
              <div class="cart-footer-left">
                <p>共 {{ cartList.length || 0 }} 件商品</p>
                <p class="total-price">总计: {{ accountTotal | decimal }} 元</p>
              </div>
              <router-link tag="div" class="cart-footer-right" to="/shoppingcart" style="color:white">去购物车结算</router-link>
            </div>
          </div>
        </template>
        <!-- 购物车没有东西的时候 -->
        <div class="empty" v-else>
          <el-image :src="require('../assets/img/noresult.png')" fit="fill"></el-image>
          <p class="tips">您的购物车里什么都没有哦</p>
          <router-link tag="div" class="btn-look" to="/goodsList">再去看看吧</router-link>
        </div>
      </div>
    </el-drawer>
    <!-- 购物车 结束 -->
  </div>
</template>

<script>
export default {
  name: "fixedRight",
  data() {
    return {
      avatar: require('../assets/img/avatar.png'),
      loading: false,
      cartShow: false,
      centerDialogVisible: false,
    }
  },
  computed: {
    isLogin () {
      return this.$store.getters.isLogin
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    cartList() {
      return this.$store.getters.cartSkus;
    },
    accountTotal() {
      return this.$store.getters.accountTotal;
    },
    msgCount () {
      return this.$store.state.countData.msgCount;
    },
    noticeCount () {
      return this.$store.state.countData.noticeCount;
    },
    informations() {
      return this.$store.state.copyrights || ''
    }
  },
  methods: {
    copyNumber (number) {
      this.$utils.doCopy(number);
      this.$message.success('客服电话已复制！');
    },
    showCart () {
      this.$tools.isLogin(() => {
        this.cartShow = true;
      });
    },
    navigateTo (path) {
      this.cartShow = false;
      this.$tools.isLogin(() => {
        this.$router.push(path);
      });
    }
  }
}
</script>

<style lang="less" scoped>
.rightNav {
  width: 40px;
  position: fixed;
  background: #444851;
  top: 0;
  right: 0;
  bottom: 0;
  color: #FFFFFF;
  font-size: 26px;
  padding-top: 15%;
  box-sizing: border-box;
  text-align: center;
  z-index: 9999;
  .nav-item{
    width: 40px;
    height: 40px;
    margin: 10px 0;
    line-height: 40px;
    cursor: pointer;
    transition-duration: 0.2s;
    &:hover{
      background-color: var(--main-theme-color);
    }
    /deep/ .el-avatar{
      margin-top: 6px;
    }
  }
  .nav-cart{
    padding: 20px 0;
    cursor: pointer;
    transition-duration: 0.2s;
    &:hover{
      background-color: var(--main-theme-color);
    }
    .cart-text{
      font-size: 18px;
      padding: 0 10px;
    }
  }
}
.user-box{
  text-align: center;
  .user-box-footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    .user-box-footer-item{
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
    .userCenter{
      color: #ff6700;
    }
    .orderCenter{
      color: #28a0fd;
    }
  }
}
.service-box{
  text-align: center;
  .service-box-item{
    padding: 10px;
    cursor: pointer;
  }
  .icon{
    font-size: 26px;
    margin-bottom: 5px;
  }
  .el-icon-chat-dot-round{
    color: var(--main-theme-color);
  }
  .el-icon-phone-outline{
    color: #00caff;
  }
}
.drawerCartTitle{
  font-size: 16px;
  font-weight: bold;
  .icon{
    font-weight: bolder;
  }
}
/deep/ .el-drawer__header{
  margin-bottom: 0;
}
.cart-content{
  padding: 15px 55px 15px 15px;
}
.empty{
  padding: 200px 0;
  text-align: center;
  .btn-look{
    display: inline-block;
    text-align: center;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    color: var(--main-theme-color);
    border: 1px solid var(--main-theme-color);
    border-radius: 3px;
    margin: 15px;
    cursor: pointer;
  }
}
.good-box{
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(220,220,220,0.7);
  .good-cover{
    width: 80px;
    height: 80px;
    border-radius: 5px;
    background-color: #F5F5F5;
  }
  .good-info{
    padding-left: 10px;
    flex:1;
    .good-title{
      font-size: 16px;
      font-weight: 500;
      margin: 5px 0;
    }
    .good-tags{
      display: inline-block;
      padding: 0 10px;
      font-size: 12px;
      background-color: rgba(255, 84, 0, 0.2);
      border-radius: 3px;
    }
    .good-count{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 5px;
      .price{
        color: var(--main-theme-color);
        font-size: 14px;
        font-weight: 500;
        &:before{
          content: '￥';
          font-size: 12px;
        }
      }
    }
  }
}
.cart-footer{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 60px 10px 20px;
  .cart-footer-left{
    flex: 1;
    font-size: 14px;
    .total-price{
      font-size: 16px;
      color: var(--main-theme-color);
      font-weight: 500;
    }
  }
  .cart-footer-right{
    height: 40px;
    padding: 0 20px;
    text-align: center;
    line-height: 40px;
    background: var(--main-theme-color);
    color: white;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixedRight.vue